import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {NumberToPersianLetters, ToxicDigitsFixToEnglish} from "../../../components/techaran/money";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsStaffAddEditSalarySourceModal = (props: {
    active: boolean,
    closeHandler: any,
    edit: boolean,
    sourceId: number,
    title: string,
    price: number,
    onDone: any,
    staffId: string,
}) => {
    const ids = {
        title: useId(),
        price: useId(),
    };
    const [title, setTitle] = useState('');
    const [price, setPrice] = useState('');
    const [err, setErr] = useState({
        title: false,
        price: false,
    });
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.edit;
        const _title = props.title;
        const _price = props.price;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            if (isEdit) {
                setTitle(_title);
                setPrice(_price.toString());
            } else {
                setTitle('');
                setPrice('');
            }
            setErr({
                title: false,
                price: false,
            });
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const _title = title.trim();
        const _price = price.trim();
        let errors = {
            title: false,
            price: false,
        };
        let stop = false;
        if (_title.length < 2) {
            errors.title = true;
            stop = true;
        }
        if (_price === '') {
            errors.price = true;
            stop = true;
        }
        setErr(errors);
        if (stop)
            return;
        const isEdit = props.edit;
        const staffId = props.staffId;
        const source = props.sourceId;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/details/sources/' + (isEdit ? 'edit' : 'add'),
            {
                id: staffId,
                source: source,
                price: _price,
                title: _title,
            },
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    isEdit ? 'منبع حقوقی ویرایش شد.' : 'منبع حقوقی جدید افزوده شد.',
                    'باشه',
                    5000,
                );
                props.closeHandler();
                props.onDone();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>{props.edit ? 'ویرایش منبع حقوق' : 'افزودن منبع حقوق'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={ids.title}>عنوان:</label>
                        <input type="text"
                               className={"form-control" + (err.title ? ' is-invalid' : '')}
                               id={ids.title}
                               value={title}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setTitle(t);
                                   setErr(v => {
                                       let x = {...v};
                                       x.title = false;
                                       return x;
                                   });
                               }}
                        />
                        <div className={"invalid-feedback" + (err.title ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۲ کاراکتر وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <label htmlFor={ids.price}>مبلغ دستمزد:</label>
                        <input type="number"
                               className={"form-control" + (err.price ? ' is-invalid' : '')}
                               id={ids.price}
                               min={0}
                               value={price}
                               onChange={e => {
                                   const t = e.currentTarget.value;
                                   setPrice(ToxicDigitsFixToEnglish(t));
                                   setErr(v => {
                                       let x = {...v};
                                       x.price = false;
                                       return x;
                                   });
                               }}
                        />
                        {
                            price !== '' ?
                                <span style={{
                                    display: 'block',
                                    margin: '5px 0 0 0',
                                    fontWeight: 400,
                                    color: '#0a53be'
                                }}>{NumberToPersianLetters(parseInt(price)) + " تومان"}</span> : null
                        }
                        <div className={"invalid-feedback" + (err.price ? ' d-block' : ' d-none')}>
                            لطفا یک مبلغ وارد نمایید.
                        </div>
                        <div style={{height: 20}}/>
                        <div className="d-flex justify-content-end align-items-center" style={{gap: 10, marginTop: 20}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره تغییرات</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};